export default __webpack_public_path__ + "static/嘉宾头像_刘峥-5cc8f1a66890c72afba2daf2b529e136.png";